import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css} from "@emotion/react";
import {Alerts} from "@web2/ap-alerts";
import {RequestState} from "@web2/ap-request-state";
import {BounceLoader, CenterBox} from "@web2/ui_utils";

import {restoreUserSession} from "../actions/restore_session";
import {IAPStore} from "../reducers/ap_reducer";
import {Routes} from "../Routes";

export const Layout = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(restoreUserSession());
    }, []);

    const isAuthenticatedRequestState = useSelector((store: IAPStore) => store.account.userSessionRestoreRequestState);
    return (
        <>
            <Alerts />
            {isAuthenticatedRequestState === RequestState.Waiting || isAuthenticatedRequestState === RequestState.None ? (
                <CenterBox css={fullHeight}>
                    <BounceLoader />
                </CenterBox>
            ) : (
                <Routes />
            )}
        </>
    );
};

const fullHeight = css`
    height: 100vh;
`;
